<template>
  <v-card class="base_card" elevation="10">
    <v-card-item v-if="title" class="pt-6 pb-4 px-6">
      <div class="d-sm-flex align-center">
        <v-card-title class="text-h4">{{ title }}</v-card-title>
        <slot name="title"></slot>
        <template v-if="expand">
          <v-spacer></v-spacer>
          <v-btn
            :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            @click="show = !show"
            variant="text"
          ></v-btn>
        </template>
      </div>
      <slot name="subTitle"></slot>
    </v-card-item>
    <v-expand-transition v-if="show">
      <slot name="expand"></slot>
    </v-expand-transition>
    <v-card-text>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: "",
  },
  expand: {
    type: Boolean,
    default: false,
  },
});

const show = defineModel<boolean>("show", { default: false });
</script>
